export enum InputType {
  Text = 'text',
  Number = 'number',
  Email = 'email',
  Password = 'password',
  Search = 'search',
  Tel = 'tel',
  Url = 'url',
  Date = 'date',
  Time = 'time',
  DateTime = 'datetime',
  Month = 'month',
  Week = 'week',
  Color = 'color',
  Range = 'range',
  Checkbox = 'checkbox',
  Radio = 'radio',
  File = 'file',
  Image = 'image',
  Button = 'button',
  Submit = 'submit',
  Reset = 'reset',
  Hidden = 'hidden',
  Textarea = 'textarea',
  Select = 'select',
}
